<template>
  <!--begin::Dashboard-->
  <div class="p-5 container">
    <div class="row mb-5" style="padding: 2vh;">
      <div class="col-12">
        <button class="btn btn-link" style="display: flex;align-items: center;}" @click="onBack()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="46"
            height="46"
            viewBox="0 0 46 46"
            fill="none"
          >
            <path
              d="M15.8879 21.6391C15.7134 21.8214 15.5766 22.0363 15.4854 22.2716C15.2937 22.7382 15.2937 23.2616 15.4854 23.7283C15.5766 23.9635 15.7134 24.1785 15.8879 24.3608L21.6379 30.1108C21.9988 30.4717 22.4883 30.6744 22.9987 30.6744C23.5091 30.6744 23.9986 30.4717 24.3595 30.1108C24.7204 29.7498 24.9232 29.2603 24.9232 28.7499C24.9232 28.2395 24.7204 27.75 24.3595 27.3891L21.8679 24.9166H28.7487C29.257 24.9166 29.7445 24.7147 30.104 24.3552C30.4634 23.9958 30.6654 23.5083 30.6654 22.9999C30.6654 22.4916 30.4634 22.0041 30.104 21.6446C29.7445 21.2852 29.257 21.0833 28.7487 21.0833H21.8679L24.3595 18.6108C24.5392 18.4326 24.6818 18.2206 24.7791 17.987C24.8764 17.7535 24.9265 17.5029 24.9265 17.2499C24.9265 16.9969 24.8764 16.7464 24.7791 16.5128C24.6818 16.2793 24.5392 16.0673 24.3595 15.8891C24.1814 15.7094 23.9694 15.5669 23.7358 15.4695C23.5022 15.3722 23.2517 15.3221 22.9987 15.3221C22.7457 15.3221 22.4952 15.3722 22.2616 15.4695C22.028 15.5669 21.816 15.7094 21.6379 15.8891L15.8879 21.6391ZM3.83203 22.9999C3.83203 26.7907 4.95614 30.4964 7.0622 33.6484C9.16826 36.8003 12.1617 39.2569 15.6639 40.7076C19.1662 42.1583 23.02 42.5379 26.7379 41.7983C30.4559 41.0588 33.8711 39.2333 36.5516 36.5528C39.2321 33.8723 41.0575 30.4571 41.7971 26.7392C42.5366 23.0212 42.1571 19.1674 40.7064 15.6652C39.2557 12.1629 36.7991 9.16948 33.6471 7.06342C30.4952 4.95736 26.7895 3.83325 22.9987 3.83325C20.4817 3.83325 17.9893 4.32901 15.6639 5.29223C13.3385 6.25544 11.2256 7.66725 9.44582 9.44704C5.85137 13.0415 3.83203 17.9166 3.83203 22.9999ZM38.332 22.9999C38.332 26.0326 37.4328 28.9971 35.7479 31.5187C34.0631 34.0402 31.6683 36.0055 28.8665 37.1661C26.0647 38.3266 22.9817 38.6303 20.0073 38.0386C17.0329 37.447 14.3008 35.9866 12.1564 33.8422C10.012 31.6978 8.55163 28.9657 7.95999 25.9913C7.36835 23.0169 7.672 19.9339 8.83255 17.1321C9.99309 14.3303 11.9584 11.9356 14.48 10.2507C17.0015 8.56587 19.9661 7.66659 22.9987 7.66659C27.0654 7.66659 30.9654 9.28206 33.841 12.1576C36.7166 15.0332 38.332 18.9333 38.332 22.9999Z"
              fill="#323563"
            />
          </svg>
          <span class="text-section" style="color:#000;font-weight: 700;">การสอบของฉัน</span>
        </button>
      </div>
      <div class="col-12 col-lg-5">
        <img
          v-if="listData"
          :src="listData && listData.thumbnailsPath != null  ? imageUrl + listData.thumbnailsPath : 'media/image-app/no-image.svg'"
          alt=""
          @error="setAltImg"
          class="w-100 mb-3"
          style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            object-fit: cover;
            height: 350px;border-radius: 20px;
            border: 1px solid #dbdbdb;"
        />
        <div>
          <div class="row">
            <div class="col-12 col-md-6">
              <p class="text-category" style="font-weight: 700;color: #323563;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M11 2C9.02219 2 7.08879 2.58649 5.4443 3.6853C3.79981 4.78412 2.51809 6.3459 1.76121 8.17317C1.00433 10.0004 0.806299 12.0111 1.19215 13.9509C1.578 15.8907 2.53041 17.6725 3.92894 19.0711C5.32746 20.4696 7.10929 21.422 9.0491 21.8079C10.9889 22.1937 12.9996 21.9957 14.8268 21.2388C16.6541 20.4819 18.2159 19.2002 19.3147 17.5557C20.4135 15.9112 21 13.9778 21 12C21 10.6868 20.7413 9.38642 20.2388 8.17317C19.7363 6.95991 18.9997 5.85752 18.0711 4.92893C17.1425 4.00035 16.0401 3.26375 14.8268 2.7612C13.6136 2.25866 12.3132 2 11 2ZM11 20C9.41775 20 7.87104 19.5308 6.55544 18.6518C5.23985 17.7727 4.21447 16.5233 3.60897 15.0615C3.00347 13.5997 2.84504 11.9911 3.15372 10.4393C3.4624 8.88743 4.22433 7.46197 5.34315 6.34315C6.46197 5.22433 7.88743 4.4624 9.43928 4.15372C10.9911 3.84504 12.5997 4.00346 14.0615 4.60896C15.5233 5.21447 16.7727 6.23984 17.6518 7.55544C18.5308 8.87103 19 10.4177 19 12C19 14.1217 18.1572 16.1566 16.6569 17.6569C15.1566 19.1571 13.1217 20 11 20ZM11 6C10.7348 6 10.4804 6.10536 10.2929 6.29289C10.1054 6.48043 10 6.73478 10 7V11.42L7.9 12.63C7.70736 12.7392 7.5564 12.9092 7.47078 13.1134C7.38517 13.3176 7.36975 13.5444 7.42695 13.7583C7.48414 13.9722 7.61072 14.1611 7.78682 14.2953C7.96292 14.4296 8.17859 14.5015 8.4 14.5C8.57518 14.5012 8.7476 14.4564 8.9 14.37L11.5 12.87L11.59 12.78L11.75 12.65C11.7891 12.6005 11.8226 12.5468 11.85 12.49C11.8826 12.4363 11.9094 12.3793 11.93 12.32C11.9572 12.2564 11.9741 12.1889 11.98 12.12L12 12V7C12 6.73478 11.8946 6.48043 11.7071 6.29289C11.5196 6.10536 11.2652 6 11 6Z"
                    fill="#9999D3"
                  />
                </svg>
                เวลาทำข้อสอบ : <span style="color:#DA595A">{{listData && listData.limitTime}} นาที</span>
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p class="text-category" style="font-weight: 700;color: #323563;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M21.1715 2.06012C20.4547 1.93665 19.7289 1.8731 19.0015 1.87012C16.5199 1.86809 14.09 2.57969 12.0015 3.92012C9.9077 2.59729 7.4782 1.90315 5.00155 1.92012C4.2742 1.9231 3.54835 1.98665 2.83155 2.11012C2.59676 2.1506 2.38413 2.27358 2.23196 2.45691C2.0798 2.64025 1.99809 2.87189 2.00155 3.11012V15.1101C1.99941 15.2571 2.02968 15.4027 2.0902 15.5366C2.15072 15.6705 2.24002 15.7894 2.35172 15.8849C2.46343 15.9803 2.59481 16.05 2.73651 16.089C2.8782 16.1279 3.02674 16.1351 3.17155 16.1101C4.60457 15.862 6.07275 15.9032 7.48962 16.2312C8.90648 16.5592 10.2434 17.1675 11.4215 18.0201L11.5415 18.0901H11.6515C11.7625 18.1363 11.8814 18.1601 12.0015 18.1601C12.1217 18.1601 12.2406 18.1363 12.3516 18.0901H12.4615L12.5815 18.0201C13.7515 17.1484 15.0846 16.5205 16.5017 16.1735C17.9188 15.8265 19.3912 15.7675 20.8315 16.0001C20.9764 16.0251 21.1249 16.0179 21.2666 15.979C21.4083 15.94 21.5397 15.8703 21.6514 15.7749C21.7631 15.6794 21.8524 15.5605 21.9129 15.4266C21.9734 15.2927 22.0037 15.1471 22.0015 15.0001V3.00012C21.9911 2.77228 21.9032 2.55483 21.7522 2.38386C21.6012 2.21289 21.3964 2.09866 21.1715 2.06012ZM11.0015 15.3501C9.15143 14.3768 7.09207 13.8688 5.00155 13.8701C4.67155 13.8701 4.34155 13.8701 4.00155 13.8701V3.87012C4.33461 3.85093 4.66849 3.85093 5.00155 3.87012C7.13494 3.86776 9.22176 4.49381 11.0015 5.67012V15.3501ZM20.0015 13.9101C19.6615 13.9101 19.3315 13.9101 19.0015 13.9101C16.911 13.9088 14.8517 14.4168 13.0015 15.3901V5.67012C14.7813 4.49381 16.8682 3.86776 19.0015 3.87012C19.3346 3.85093 19.6685 3.85093 20.0015 3.87012V13.9101ZM21.1715 18.0601C20.4547 17.9367 19.7289 17.8731 19.0015 17.8701C16.5199 17.8681 14.09 18.5797 12.0015 19.9201C9.91306 18.5797 7.48318 17.8681 5.00155 17.8701C4.2742 17.8731 3.54835 17.9367 2.83155 18.0601C2.70138 18.0808 2.57657 18.127 2.46431 18.196C2.35205 18.2651 2.25455 18.3557 2.17742 18.4625C2.10028 18.5694 2.04503 18.6905 2.01485 18.8188C1.98467 18.9471 1.98015 19.0801 2.00155 19.2101C2.05237 19.4698 2.20404 19.6988 2.42334 19.8468C2.64264 19.9949 2.91169 20.05 3.17155 20.0001C4.60457 19.752 6.07275 19.7932 7.48962 20.1212C8.90648 20.4492 10.2434 21.0575 11.4215 21.9101C11.5909 22.0307 11.7936 22.0955 12.0015 22.0955C12.2095 22.0955 12.4122 22.0307 12.5815 21.9101C13.7597 21.0575 15.0966 20.4492 16.5135 20.1212C17.9303 19.7932 19.3985 19.752 20.8315 20.0001C21.0914 20.05 21.3605 19.9949 21.5798 19.8468C21.7991 19.6988 21.9507 19.4698 22.0015 19.2101C22.0229 19.0801 22.0184 18.9471 21.9882 18.8188C21.9581 18.6905 21.9028 18.5694 21.8257 18.4625C21.7485 18.3557 21.651 18.2651 21.5388 18.196C21.4265 18.127 21.3017 18.0808 21.1715 18.0601Z"
                    fill="#9999D3"
                  />
                </svg>
                จำนวนข้อสอบ : {{listData && listData.totalQuestion}} ข้อ
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p class="text-category" style="font-weight: 700;color: #323563;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M14.72 8.79L10.43 13.09L8.78 11.44C8.69036 11.3353 8.58004 11.2503 8.45597 11.1903C8.33191 11.1303 8.19678 11.0965 8.05906 11.0912C7.92134 11.0859 7.78401 11.1091 7.65568 11.1594C7.52736 11.2096 7.41081 11.2859 7.31335 11.3833C7.2159 11.4808 7.13964 11.5974 7.08937 11.7257C7.03909 11.854 7.01589 11.9913 7.02121 12.1291C7.02653 12.2668 7.06026 12.4019 7.12028 12.526C7.1803 12.65 7.26532 12.7604 7.37 12.85L9.72 15.21C9.81344 15.3027 9.92426 15.376 10.0461 15.4258C10.1679 15.4755 10.2984 15.5008 10.43 15.5C10.6923 15.4989 10.9437 15.3947 11.13 15.21L16.13 10.21C16.2237 10.117 16.2981 10.0064 16.3489 9.88458C16.3997 9.76272 16.4258 9.63201 16.4258 9.5C16.4258 9.36799 16.3997 9.23728 16.3489 9.11542C16.2981 8.99356 16.2237 8.88296 16.13 8.79C15.9426 8.60375 15.6892 8.49921 15.425 8.49921C15.1608 8.49921 14.9074 8.60375 14.72 8.79ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20Z"
                    fill="#9999D3"
                  />
                </svg>
                เกณฑ์การผ่าน : {{listData && listData.percentPass}}%
              </p>
            </div>
            <div class="col-12 col-md-6">
              <p class="text-category" style="font-weight: 700;color: #323563;">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20 8.94C19.9896 8.84813 19.9695 8.75763 19.94 8.67V8.58C19.8919 8.47718 19.8278 8.38267 19.75 8.3L13.75 2.3C13.6673 2.22222 13.5728 2.15808 13.47 2.11C13.4402 2.10576 13.4099 2.10576 13.38 2.11C13.2784 2.05174 13.1662 2.01434 13.05 2H7C6.20435 2 5.44129 2.31607 4.87868 2.87868C4.31607 3.44129 4 4.20435 4 5V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V9C20 9 20 9 20 8.94ZM14 5.41L16.59 8H15C14.7348 8 14.4804 7.89464 14.2929 7.70711C14.1054 7.51957 14 7.26522 14 7V5.41ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H12V7C12 7.79565 12.3161 8.55871 12.8787 9.12132C13.4413 9.68393 14.2044 10 15 10H18V19ZM14.29 12.29L11 15.59L9.71 14.29C9.5217 14.1017 9.2663 13.9959 9 13.9959C8.7337 13.9959 8.4783 14.1017 8.29 14.29C8.1017 14.4783 7.99591 14.7337 7.99591 15C7.99591 15.2663 8.1017 15.5217 8.29 15.71L10.29 17.71C10.383 17.8037 10.4936 17.8781 10.6154 17.9289C10.7373 17.9797 10.868 18.0058 11 18.0058C11.132 18.0058 11.2627 17.9797 11.3846 17.9289C11.5064 17.8781 11.617 17.8037 11.71 17.71L15.71 13.71C15.8983 13.5217 16.0041 13.2663 16.0041 13C16.0041 12.7337 15.8983 12.4783 15.71 12.29C15.5217 12.1017 15.2663 11.9959 15 11.9959C14.7337 11.9959 14.4783 12.1017 14.29 12.29Z"
                    fill="#9999D3"
                  />
                </svg>
                คะแนนเต็ม : {{listData && listData.totalScore}} คะแนน
              </p>
            </div>
          </div>

          <button
            type="button"
            @click="register()"
            class="btn btn  btn-learn w-100"
          >
            เริ่มทำแบบทดสอบ
          </button>
        </div>
      </div>
      <div class="col-12 col-lg-7">
        <p class="text-section" style="font-weight: 700;color: #333333;">
          {{ listData ? listData.title : "" }}
        </p>
        <p class="text-category" style="font-weight: 700;color: #333333;">
          รหัสแบบทดสอบ :<span style="color: #DA595A;">{{
            listData ? listData.examCode : ""
          }}</span>
        </p>
        <!-- <p class="text-category" style="font-weight: 700;color: #333333;">
          องค์กร :
          <span style="color: #DA595A;"></span>
        </p> -->
        <p class="text-category" style="font-weight: 700;color: #333333;">
          ผู้จัดทำ :
          <span style="color: #DA595A;">{{
            listData && listData.organization ? listData.organization : "-"
          }}</span>
        </p>
        <hr />
        <p class="text-category" style="font-weight: 700;color: #333333;">
          รายละเอียดแบบทดสอบ
        </p>
        <p
          class="text-category"
          v-html="listData ? listData.description : ''"
          style="font-weight: 400;
                color: #7F7F81;"
        ></p>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
const listData = ref();

export default defineComponent({
  name: "exam-general-detail",
  components: {},
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      countDown: 0,
      countDownTime: "",
      examReady: false,
    };
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
      router.go(0);
    }
    onMounted(() => {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      getDataList();
    });
    const getDataList = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getExam?id=" +
            route.params.id +
            "&examType=1",
          {
            headers: {
              token: localStorage.getItem("id_token")
            },
          }
        )
        .then((response) => {
          // console.log("getExam");
          console.log(response.data.data.content[0]);
          listData.value = response.data.data.content[0];
          setCurrentPageBreadcrumbs( listData.value.title, []);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const register = () => {
      if (localStorage.getItem("id_token")) {
        localStorage.setItem("reloaded" , "1")
        router.push({
          name: "exam-general-learn",
          params: {
            id: route.params.id,
          },
        });
      } else {
        router.push({ name: "sign-in" });
      }
    };
    return {
      getDataList,
      listData,
      register,
    };
  },
  methods: {
    setAltImg(event) {
      event.target.src = "media/image-app/no-image.svg";
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    onBack(){
        this.$router.go(-1)
    }
  },
});
</script>
<style>
.btn-app {
  background: #da595a;
  color: #ffffff;
  border-radius: 100px;
}
.btn-app2 {
  background: #323563;
  color: #ffffff;
  border-radius: 100px;
}
.btn-register {
  background: #f2a17d;
  color: #ffffff;
  width: 70%;
  border-radius: 21px;
}
.btn-learn {
  width: 70%;
  color: #ffffff;
  background: #323563;
  border-radius: 21px;
}
</style>
